import { GetServerSideProps } from 'next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTutorDetail } from '@/actions/tutor';
import TutorDetailComponent from '@/components/landing/tutor/all-tutors/tutorDetail';
import Footer from '@/components/layout/landing/Footer';
import Navbar from '@/components/layout/landing/Navbar';
import Head from 'next/head';
import PageBanner from '@/components/landing/common/PageBanner';
import APIServices from '@/apiUtils/APIServices';
import { useRouter } from 'next/router';
import ErrorPage from '../404';
import useWidth from '@/helpers/widthUtil';
import LandingLayout from '@/components/landing/home/LandingLayout';

const TutorProfile = (props) => {
  const { isMobile } = useWidth();
  const router = useRouter();
  if (props.data === null) {
    return <ErrorPage />;
  }
  useEffect(() => {
    console.log(props)
  }, [props])

  return (
    <>
      <Head>
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SITE_URL}tutor/${props?.username}`}
        />
      </Head>
      <LandingLayout>

        {
          !isMobile &&
          <PageBanner
            pageTitle="Instructor Details"
            breadcrumbTextOne="Home"
            breadcrumbTextTwo="Instructor Details"
            breadcrumbUrl="/"
            className="tutor-banner"
          />
        }
        <TutorDetailComponent {...props} />
      </LandingLayout>
    </>
  );
};

export default TutorProfile;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const username = context.query?.username;
  const { data, success } = await new APIServices(
    `instructor-list/${username}`
  ).get();
  return {
    props: {
      data: success ? data : null,
      username,
    },
  };
};
